import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/ga4';

// Hook to automatically track page views on route changes
export const useGA4PageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    trackPageView(location.pathname + location.search);
  }, [location]);
};

// Hook for tracking specific page views with custom data
export const useGA4CustomPageTracking = (pageTitle?: string, customData?: Record<string, any>) => {
  const location = useLocation();

  useEffect(() => {
    // Track page view with custom title and data
    trackPageView(location.pathname + location.search, pageTitle);
    
    // Track additional custom data if provided
    if (customData) {
      const { trackEvent } = require('../utils/ga4');
      trackEvent('page_view_custom', {
        page_path: location.pathname,
        page_title: pageTitle || document.title,
        ...customData,
      });
    }
  }, [location, pageTitle, customData]);
};
